/**
 * @desc 删除年度销售计划指标
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 主键id */
  id: number;
}

export function request(params: Params): Promise<defs.StandardReturn<boolean>> {
  return defHttp.delete({
    url: '/wap/sale/indicator/delete',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<boolean>> {
  return defHttp.delete({
    url: '/mock/wap/sale/indicator/delete',

    params,
  });
}
